import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "text-center"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "notification__mount" }
const _hoisted_5 = {
  key: 0,
  class: "notification__circle notification__circle--read"
}
const _hoisted_6 = {
  key: 1,
  class: "notification__circle notification__circle--unread"
}
const _hoisted_7 = { class: "notification__message" }
const _hoisted_8 = { class: "notification__time" }
const _hoisted_9 = { class: "notification__item pointer-cursor" }
const _hoisted_10 = { class: "notification__mount" }
const _hoisted_11 = {
  key: 0,
  class: "notification__circle notification__circle--read"
}
const _hoisted_12 = {
  key: 1,
  class: "notification__circle notification__circle--unread"
}
const _hoisted_13 = { class: "notification__message" }
const _hoisted_14 = { class: "notification__time" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "notification__mount" }
const _hoisted_17 = {
  key: 0,
  class: "notification__circle notification__circle--read"
}
const _hoisted_18 = {
  key: 1,
  class: "notification__circle notification__circle--unread"
}
const _hoisted_19 = { class: "notification__message" }
const _hoisted_20 = { class: "notification__time" }
const _hoisted_21 = {
  key: 2,
  class: "notification__item"
}
const _hoisted_22 = { class: "notification__mount" }
const _hoisted_23 = {
  key: 0,
  class: "notification__circle notification__circle--read"
}
const _hoisted_24 = {
  key: 1,
  class: "notification__circle notification__circle--unread"
}
const _hoisted_25 = { class: "notification__message" }
const _hoisted_26 = { class: "notification__time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_infinite_scroll = _resolveComponent("v-infinite-scroll")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    class: "notification",
    modelValue: _ctx.notificationDrawerOpen,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.notificationDrawerOpen) = $event)),
    temporary: true,
    location: "right",
    width: "360",
    ref: "navigationDrawer",
    order: 3
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_infinite_scroll, {
        items: _ctx.notifications,
        onLoad: _ctx.loadItems
      }, {
        empty: _withCtx(() => [
          (_ctx.notifications?.length > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, "All notifications displayed."))
            : (_openBlock(), _createElementBlock("p", _hoisted_2, "No new notifications."))
        ]),
        default: _withCtx(() => [
          (_ctx.$store.getters['Notifications/hasData'])
            ? (_openBlock(), _createBlock(_component_v_container, {
                key: 0,
                fluid: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { class: "notification__item mb-0 pb-2 pt-2" }, {
                        default: _withCtx(() => [
                          _createElementVNode("button", {
                            class: "ben-btn text-center w-100",
                            variant: "text",
                            onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.markAllNotificationsRead && _ctx.markAllNotificationsRead(...args)), ["stop"]))
                          }, " Mark all as read ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification) => {
            return (_openBlock(), _createElementBlock("div", {
              key: notification.id
            }, [
              (notification.parameters && notification.parameters.internalLink)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.isOnLink(notification.parameters.internalLink))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          onClick: _withModifiers(($event: any) => (_ctx.reload(notification.parameters.internalLink)), ["prevent"]),
                          class: "notification__item pointer-cursor"
                        }, [
                          _createElementVNode("div", _hoisted_4, [
                            (notification.read)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                              : (_openBlock(), _createElementBlock("div", _hoisted_6)),
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("p", null, _toDisplayString(notification.message), 1),
                              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "notification__link" }, " Click to view details > ", -1))
                            ]),
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.localizedDate(notification.date)), 1)
                          ]),
                          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "notification__divider" }, null, -1))
                        ], 8, _hoisted_3))
                      : (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: _ctx.getTo(notification.parameters.internalLink)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                (notification.read)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_11))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_12)),
                                _createElementVNode("div", _hoisted_13, [
                                  _createElementVNode("p", null, _toDisplayString(notification.message), 1),
                                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "notification__link" }, " Click to view details > ", -1))
                                ]),
                                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.localizedDate(notification.date)), 1)
                              ]),
                              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "notification__divider" }, null, -1))
                            ])
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                  ], 64))
                : (notification.parameters && notification.parameters.externalLink)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      class: "notification__item pointer-cursor",
                      href: notification.parameters.externalLink,
                      target: "_blank"
                    }, [
                      _createElementVNode("div", _hoisted_16, [
                        (notification.read)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17))
                          : (_openBlock(), _createElementBlock("div", _hoisted_18)),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("p", null, _toDisplayString(notification.message), 1),
                          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "notification__link" }, " Click to view details > ", -1))
                        ]),
                        _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.localizedDate(notification.date)), 1)
                      ]),
                      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "notification__divider" }, null, -1))
                    ], 8, _hoisted_15))
                  : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        (notification.read)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23))
                          : (_openBlock(), _createElementBlock("div", _hoisted_24)),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("p", null, _toDisplayString(notification.message), 1)
                        ]),
                        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.localizedDate(notification.date)), 1)
                      ]),
                      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "notification__divider" }, null, -1))
                    ]))
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["items", "onLoad"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}